import axios from 'axios';

export function gqlGet(endpoint, query, options = { token: '', traceId: '' }) {
    const { token, traceId } = options;

    return new Promise((resolve) => {
        const reqHeaders = {
            authorization: 'Bearer ' + token,
            'x-trace-id': traceId,
        };
        axios.get(endpoint, { headers: reqHeaders, params: { query } })
            .then(resolve)
            .catch(resolve);
    });
}

export default gqlGet;
